<template>
  <div>
    <datatable
      title="Admin Feed Designators"
      @create="createFeedDesignator"
      @delete="deleteFeedDesignator"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'admin-feed-designators',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'group',
          value: 'group'
        },
        {
          name: 'designator',
          value: 'designator'
        },
        {
          name: 'minimum_permission',
          value: 'minimum_permission'
        },
        {
          name: 'maximum_permission',
          value: 'maximum_permission'
        },
        {
          name: 'priority',
          value: 'priority'
        },
        {
          name: 'time_estimation',
          value: 'time_estimation'
        },
        {
          name: 'before_answer_time_estimation',
          value: 'before_answer_time_estimation'
        },
        {
          name: 'information',
          value: 'information'
        }
      ],
      data: []
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getAllFeedDesignators().then(response => {
        this.data = response
      })
    },
    createFeedDesignator () {
      this.create({ designator: 'admin-feed-designators-form-modal', component_name: 'AdminFeedDesignatorsForm', is_create: true, modal_title: 'Create new Feed Designator' })
    },
    deleteFeedDesignator (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.group,
        item_name: delete_data.group,
        method: 'deleteFeedDesignator',
        method_params: { id: delete_data.id }
      })
    },
    editClick (data) {
      this.create({ designator: 'admin-feed-designators-form-modal', component_name: 'AdminFeedDesignatorsForm', data, modal_title: data.group })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
